export class TTPModel {
  WIPSummary: JSON;
}
